import { filestackPicker } from "../framework/uploader";
import * as Popup from "../framework/components/popup.js";

/*
Open the Filestack picker and push the uploaded blob metadata to the owning LiveComponent, which
creates the Document row.

  - data-upload-event: event name pushed on success
  - data-upload-failed-event: event name pushed when the transfer fails
  - data-upload-path:  S3 path prefix (Filestack rejects a root path)
  - data-upload-id:    record id, when the popup holds several (pushEventTo drops phx-value-*)
*/
const FilestackPickerHook = {
  mounted() {
    this.onClick = async () => {
      // Little flip flap with the pop up because it stays in front of the file picker window even with showModal()
      const dialog = this.el.closest("dialog[open]");

      const suspend = () => {
        if (!dialog) return;
        dialog.dataset.suspendCloseSync = "true";
        Popup.close(dialog);
      };

      const restore = () => {
        if (!dialog || dialog.open) return;
        Popup.open(dialog);
        // close() queues its event as a task; this can run as early as a microtask. Deferred so
        // the flag outlives the close it suppresses.
        setTimeout(() => delete dialog.dataset.suspendCloseSync, 0);
      };

      let filesUploaded;

      suspend();

      try {
        ({ filesUploaded } = await filestackPicker({
          path: this.el.dataset.uploadPath,
          maxFiles: 1,
          onClose: restore,
        }));
      } catch (error) {
        console.error("Filestack upload failed", error);
        this.pushEventTo(this.el, this.el.dataset.uploadFailedEvent, {});
        return;
      } finally {
        restore();
      }

      const [blob] = filesUploaded || [];
      if (!blob) return;

      const { uploadEvent, uploadId } = this.el.dataset;

      // Filestack names it `mimetype`, the Document schema expects `mime`.
      this.pushEventTo(this.el, uploadEvent, {
        url: blob.url,
        filename: blob.filename,
        mime: blob.mimetype,
        size: blob.size,
        ...(uploadId ? { id: uploadId } : {}),
      });
    };

    this.el.addEventListener("click", this.onClick);
  },

  destroyed() {
    this.el.removeEventListener("click", this.onClick);
  },
};

export default FilestackPickerHook;
